import React, {useContext} from "react";
import { useTranslation } from "react-i18next";
import "../../assets/stylesheets/sales-process.css";
import { Helmet } from "react-helmet";
import Logo from "../../assets/image/logo.svg";
import i18n from 'i18next';
import {ContactInfoContext} from "./ContactInfoContext";

function SalesProcess() {
    const { t } = useTranslation(["seales"]);
    const { contactInfo } = useContext(ContactInfoContext);

    return (
        <>
            <Helmet>
                <link rel="canonical" href={`https://sievn.am/${i18n.language}/${t("sealesProces")}`} />
                <meta property="og:url" content={`https://sievn.am/${i18n.language}/${t("sealesProces")}`} />
                <meta property="og:title" content={t("saleTitle")} />
                <meta property="og:site_name" content="sievn.am" />
                <meta property="og:description" content={t("saleDescribe")} />
                <meta property="og:image" content={Logo} />
                <meta property="og:image:width" content="1200" />
                <meta property="og:image:height" content="630" />
                <meta name="description" content={t("saleDescribe")} />
                <title>{t("saleTitle")}</title>
            </Helmet>
            <div className="sales-page">
                <div className="about-start-sales">
                    <img src={contactInfo.processUrl} alt="Sales Process" />
                </div>

                <div className="main-container-sales">
                    <div className="headings-sales">
                        <h1>
                            <em>{t("sales")}</em>
                        </h1>
                    </div>
                    <p className="content-sales">{t("salesContent")}</p>
                    <h3 className="subtitle-sales">{t("salesTitle1")}</h3>
                    <p className="content-sales">{t("salesContent1")}</p>
                    <h3 className="subtitle-sales">{t("salesTitle2")}</h3>
                    <p className="content-sales">{t("salesContent2")}</p>
                    <h3 className="subtitle-sales">{t("salesTitle3")}</h3>
                    <p className="content-sales">{t("salesContent3")}</p>
                    <p className="content-sales">{t("salesContent4")}</p>
                </div>
            </div>
        </>
    );
}

export default SalesProcess;